import { render, staticRenderFns } from "./ClCalcsAdvice.vue?vue&type=template&id=f2730f6a&scoped=true&"
import script from "./ClCalcsAdvice.vue?vue&type=script&lang=js&"
export * from "./ClCalcsAdvice.vue?vue&type=script&lang=js&"
import style0 from "./ClCalcsAdvice.vue?vue&type=style&index=0&id=f2730f6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2730f6a",
  null
  
)

export default component.exports